import {
  DeleteMembersResponse,
  FetchMembersPayload,
  GetMembersCountPayload,
  MembersResponseType,
  UpdateMember,
} from "types/MembersTypes";
import API from "./Api";
import { AxiosPromise } from "axios";
import { ApiResponse } from "types/ApiTypes";
import { INVITE_MEMBERS, MEMBERS, MEMBERS_COUNT } from "./constants";

export default class {
  static fetchMembers(
    payload?: FetchMembersPayload,
  ): AxiosPromise<ApiResponse<MembersResponseType>> {
    const {
      email = "",
      page = 0,
      role,
      seatAssigned,
      size = 15,
      sortBy,
      sortOrder,
    } = payload || {};

    // Optional params must be omitted when unset: URLSearchParams would
    // serialize undefined values as the string "undefined".
    const queryParams: Record<string, string | number> = {
      page,
      size,
      email,
    };
    if (role) {
      queryParams.role = role;
    }
    if (seatAssigned !== undefined) {
      queryParams.seatAssigned = String(seatAssigned);
    }
    if (sortBy) {
      queryParams.sortBy = sortBy;
      queryParams.sortOrder = sortOrder ?? "ASC";
    }

    return API.get(MEMBERS, queryParams);
  }

  static updateMembers(
    members: UpdateMember[],
  ): AxiosPromise<ApiResponse<MembersResponseType>> {
    return API.put(MEMBERS, {
      members,
    });
  }

  static inviteMembers(
    emails: string[],
  ): AxiosPromise<ApiResponse<MembersResponseType>> {
    return API.post(INVITE_MEMBERS, {
      addedMembers: emails,
    });
  }

  static getMembersCount(): AxiosPromise<ApiResponse<GetMembersCountPayload>> {
    return API.get(MEMBERS_COUNT);
  }

  static deleteMembers(
    emails: string[],
  ): AxiosPromise<ApiResponse<DeleteMembersResponse>> {
    return API.delete(MEMBERS, { emails });
  }
}
